import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DispatchForecast, Likelihood, LIKELIHOOD_PRIORITY, Registrations, RegistrationsResponse } from '../models/com/registrations.model';
import { ApiEndpointsService } from './api-endpoints.service';
import {REGISTRATIONS_BY_SESSION } from '../shared/graphql/registrations.query';
import moment from 'moment';
import { DISPATCH_FORECAST_RESPONSE } from '../shared/mocks/dispatch-forecast.mock';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DispatchForecastService{
  private readonly http = inject(HttpClient);
  private readonly apiService = inject(ApiEndpointsService);

  getProgramNameBySession(){
    //MOCKED DATA
    //return of(DISPATCH_FORECAST_RESPONSE as RegistrationsResponse)  
    
    const endpoint = this.apiService.baseUrl;
    const startOfWeek = moment().startOf("isoWeek"); // Monday
    const inputDates = {
      start_date: startOfWeek.format("YYYY-MM-DD"),
      end_date: startOfWeek.clone().add(6, "days").format("YYYY-MM-DD")
    };

    //console.log("input dates", inputDates)
    return this.http.post<RegistrationsResponse>(
          endpoint,{query: REGISTRATIONS_BY_SESSION,
          variables: {
                  inputDates
                }
          },
          { withCredentials: true });
          
  }

  filterProgramsByPortfolio(registrations: Registrations[]): Registrations[]{
    const seenPairs = new Set<string>();
    const result: Registrations[] = [];
    const emptyies : Registrations[] = [];
    registrations.forEach(r => {
      if (!r.product?.prez_conf?.display_dispatch_forecast_homepage) return;
      
      const normalizedForecast = normalizeDispatch(r.dispatch_forecast);
      const programId = r.program.id;
      const key = `${programId}_${JSON.stringify(normalizedForecast)}`

      if (!seenPairs.has(key)) {
        seenPairs.add(key);
        
        if(r.dispatch_forecast.length === 0){
          emptyies.push(r)
        }else{
          result.push(r)
        }
      }
    });
    //console.log("Empty programs:",emptyies)
    emptyies.forEach(e => {
      if(!result.find(r => r.program_id === e.program_id)) result.push(e)
    })
    //console.log("Result", result)
    return result;
  }

  getMostFrequentLikelihood(forecast: {likelihood: Likelihood}[]): Likelihood | null{
    if(!forecast || forecast.length ===0) return null;

    const counts: Record<Likelihood,number> = {
      HIGH: 0,
      MEDIUM: 0,
      LOW: 0,
      NA:0,
    }

    forecast.forEach(f=>{
      counts[f.likelihood]++;
    })
    
    let result: Likelihood = 'NA';
    
    (Object.keys(counts) as Likelihood []).forEach(key => {
      const better = counts[key] > counts[result] || ( counts[key] === counts[result] && LIKELIHOOD_PRIORITY[key] > LIKELIHOOD_PRIORITY[result]);
      if (better) {
        result = key;
      }
    });
    return result;
  }

}

export function normalizeDispatch(df: DispatchForecast[] = []) {
  return df
    .map(item => ({
      date: item.date,
      likelihood: item.likelihood,
      isAuditWindow: item.isAuditWindow,
      isHoliday: item.isHoliday
    }))
    .sort((a, b) => a.date.localeCompare(b.date));
}